import axios from "axios"
import { URL_BASE } from '../../../config/config'

const RESOURCE = 'financials/tenants'


export default {
    state: {
        items: {
            data: []
        },

        all_tenants: {
            data: []
        }
    },

    mutations: {
        LOAD_TENANTS (state, data) {
            state.items = data
        },

        LOAD_ALL_TENANTS (state, data) {
            state.all_tenants = data
        }
    },

    actions: {
        
        storeTenant(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve) => {
                axios.post(`${URL_BASE}${RESOURCE}`, params)
                    .then(response => resolve(response.data))
                    .catch(error => console.log(error))
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        loadTenants(context, params) {

            context.commit('PRELOADER', true)
            axios.get(`${URL_BASE}${RESOURCE}`, {params})
                .then( response =>
                        {
                            context.commit('LOAD_TENANTS', response.data)
                        }
                )
                //.catch( errors => console.log(errors))
                .catch((error) => {
                    if(error.response && error.response.status === 401) {
                        window.location.href = "login";
                    }

                })
                .finally(() => context.commit('PRELOADER', false))
        },

        async loadAllTenants({ commit, state }) {
            // Verifica se os dados já foram carregados
            if (state.all_tenants && state.all_tenants.data && state.all_tenants.data.length > 0) {
                return; // Evita nova requisição se já houver dados
            }
            
            const params = {};
            params.paginate = 'false'; 
            
            commit('PRELOADER', true);
            axios.get(`${URL_BASE}${RESOURCE}`, { params })
            .then(response => {
                commit('LOAD_ALL_TENANTS', response.data);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    window.location.href = "login";
                }
            })
            .finally(() => {
                commit('PRELOADER', false);
            });
        },
  
        updateTenant(context, params){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.put(`${URL_BASE}${RESOURCE}/${params.id}`, params)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        loadTenant(context, id) {
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}${RESOURCE}/${id}`)
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        destroyTenant(context, id){
            
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.delete(`${URL_BASE}${RESOURCE}/${id}`)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
                    //.finally(() => context.commit('PRELOADER', false))    
            })
            
        },

        changeUserClient(context, params){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.get(`${URL_BASE}financials/change_user_client`, {params})
                    .then(response => resolve(response.data))
                    .catch(function(error) {
                        if (error.response && error.response.status === 401) {
                          window.location.href = "login";
                        }
                        reject(error)
                    })
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

    },

    getters: {

    }

}